import { ACTION_MENU_LOCALE, ActionMenu } from '@/components/Post/config'
import { canShareImage } from './content'
import ShareImageMenuItem from './ShareImageMenuItem'
import type { ShareImageTarget } from './types'
import type { MenuItemData } from '../DropdownMenu/types'

export default function createShareImageMenuItem(
	target: ShareImageTarget
): MenuItemData | undefined {
	if (!canShareImage(target)) return
	return {
		...ACTION_MENU_LOCALE[ActionMenu.COPY_SHARE_IMAGE],
		render: (props) => (
			<ShareImageMenuItem {...props} key={`${target.kind}:${target.data.id}`} target={target} />
		),
	}
}
